import BloggerPhotoAi from "./BloggerPhotoAi";

export default BloggerPhotoAi;